export default function SelectList({
	options,
	value,
	setValue,
	defaultText,
	...args
}) {
	return (
		<select
			{...args}
			value={value}
			onChange={(e) => setValue(e.target.value)}
		>
            {defaultText && <option value="" hidden>{defaultText}</option>}
			{options.map((o) => (
				<option key={o.id} value={o.id}>{o.text}</option>
			))}
		</select>
	);
}
